import { AppConfigurationKey } from '../../../../model/enums/appConfigurationKey'
import { ContractCapacitiesFormModel } from '../../../../pages/contracts/contracts.model'
import { getAppConfigurationValue } from '../../../../redux'
import AxiosInstance from '../../../http-config'
import { CapacityModel } from '../../model/contracts'

export const apiPatchCapacity = async (
  newCapacity: ContractCapacitiesFormModel,
  capacityId: number
): Promise<CapacityModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  const request = newCapacity

  return await AxiosInstance.patch(
    // `https://localhost:59923/api/Capacities(${capacityId})`,
    `${apiSuffixUrl}/api/Capacities(${capacityId})`,
    request
  ).then(response => {
    if (response.data) {
      return response.data
    }
  })
}

export const apiGetCapacitiesInBetweenRange = async (
  contractID: number,
  newStartDate: string,
  newEndDate: string
): Promise<number> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    // `https://localhost:59923/api/Capacity/GetCapacitiesInBetweenRange?contractID=${contractID}&newStartDate=${newStartDate}&newEndDate=${newEndDate}`
    `${apiSuffixUrl}/api/Capacity/GetCapacitiesInBetweenRange?contractID=${contractID}&newStartDate=${newStartDate}&newEndDate=${newEndDate}`
  ).then(response => {
    if (response.data != undefined) {
      return response.data
    }
  })
}
